/**
 * @ipc/admin-ui · widgets/app-shell · route-guard — гейт доступа к экрану по RBAC.
 * Оборачивает элемент роута: если у текущего пользователя нет права экрана — показывает
 * «Недостаточно прав» вместо контента (пункт меню и так скрыт, это защита прямого перехода).
 * Авторитет остаётся за backend (403); гейт — UX-слой.
 */
import type { ReactNode } from 'react';
import { useSessionQuery } from '@/entities/session';
import { can } from '@/shared/lib';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui';

export function RouteGuard({ permission, children }: { permission: string | null; children: ReactNode }) {
  const sessionQuery = useSessionQuery();
  const user = sessionQuery.data;

  // Сессию грузит AppShell выше; здесь только проверка права (данные уже в кэше).
  if (permission !== null && user && !can(user.permissions, permission)) {
    return (
      <div className="flex flex-col gap-4">
        <h1 className="text-xl font-semibold">Доступ ограничен</h1>
        <Card className="max-w-md">
          <CardHeader>
            <CardTitle className="text-base">Недостаточно прав</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            Для просмотра этого раздела нужно право <code className="font-mono">{permission}</code>.
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
